import React from 'react';
import {
    Box,
    FormControl,
    MenuItem,
    Select,
    Typography,
} from '@mui/material';
import {blue} from '@mui/material/colors';
import moment from 'moment';
import {useTranslation} from 'react-i18next';

import {formatMinutesAsHours} from '../../helpers/DateTimeRangeHelper';
import {MONTH_YEAR_FORMAT} from '../../config/DateTimeConstants';

const styles = {
    summary: {
        container: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr',
            border: '1px solid #DADCE5',
            borderRadius: '0.75rem',
            backgroundColor: blue[50],
            marginBottom: '0.5rem',
        },
        section: {
            padding: '0.75rem',
            paddingLeft: '1rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
        },
        sectionWithBorder: {
            padding: '0.75rem',
            paddingLeft: '1rem',
            borderRight: '1px solid #DADCE5',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
        },
        monthSection: {
            padding: '0.75rem',
            paddingLeft: '1rem',
            borderRight: '1px solid #DADCE5',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
            gap: '0.75rem',
        },
        label: {
            fontSize: '0.75rem',
            fontWeight: 700,
            letterSpacing: '0.08em',
            color: '#8E8E93',
            marginBottom: '0.5rem',
        },
        monthLabel: {
            fontSize: '0.75rem',
            fontWeight: 700,
            letterSpacing: '0.08em',
            color: '#8E8E93',
        },
        value: {
            fontSize: '1.5rem',
            fontWeight: 700,
            color: '#1F1F2E',
            lineHeight: 1,
        },
        subValue: {
            marginTop: '0.4rem',
            fontSize: '0.875rem',
            color: '#9A9AA1',
        },
        selectInput: {
            backgroundColor: '#FFFFFF',
            borderRadius: '0.5rem',
            width: '12rem'
        },
    },
};

const MyHistoryShiftsSummaryTab = ({
                                    selectedMonth,
                                    monthOptions,
                                    handleMonthChange,
                                    totalShiftsCount,
                                    totalShiftMinutesIncludingAmendments,
                                    totalAmendmentsCount,
                                    amendmentsBreakdownLabel,
                                }) => {
    const {t} = useTranslation();

    return (
        <Box sx={styles.summary.container}>
            <Box sx={styles.summary.monthSection}>
                <Typography sx={styles.summary.monthLabel}>
                    {t("myHistory.shifts.summary.month")}
                </Typography>

                <FormControl size="small">
                    <Select
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        displayEmpty
                        sx={styles.summary.selectInput}
                        MenuProps={{MenuListProps: {sx: {paddingBottom: 0}}}}>
                        {monthOptions.map((month) => (
                            <MenuItem
                                key={month.value}
                                value={month.value}>
                                {month.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>

            <Box sx={styles.summary.sectionWithBorder}>
                <Typography sx={styles.summary.label}>
                    {t("myHistory.shifts.summary.totalShifts")}
                </Typography>

                <Typography sx={styles.summary.value}>
                    {totalShiftsCount}
                </Typography>

                <Typography sx={styles.summary.subValue}>
                    {moment(selectedMonth).format(MONTH_YEAR_FORMAT)}
                </Typography>
            </Box>

            <Box sx={styles.summary.sectionWithBorder}>
                <Typography sx={styles.summary.label}>
                    {t("myHistory.shifts.summary.totalHours")}
                </Typography>

                <Typography sx={styles.summary.value}>
                    {formatMinutesAsHours(totalShiftMinutesIncludingAmendments)}
                </Typography>

                <Typography sx={styles.summary.subValue}>
                    {t("myHistory.shifts.summary.totalHoursDescription")}
                </Typography>
            </Box>

            <Box sx={styles.summary.section}>
                <Typography sx={styles.summary.label}>
                    {t("myHistory.shifts.summary.amendments")}
                </Typography>

                <Typography sx={styles.summary.value}>
                    {totalAmendmentsCount}
                </Typography>

                <Typography sx={styles.summary.subValue}>
                    {amendmentsBreakdownLabel}
                </Typography>
            </Box>
        </Box>
    );
};

export default MyHistoryShiftsSummaryTab;